import { useState, useEffect } from 'react';
import { api, ApiError } from '../lib/api';
import { useAuth } from './useAuth';
import { useMarinaModulesRefresh } from '../context/MarinaModulesRefreshContext';

/**
 * True when marina_modules has parking (or legacy caravan) enabled — nav, Bookings tab.
 * Aligns with widget / public API / AI toolLoader (`parking` | `caravan`).
 */
export function useParkingModule(): { parkingEnabled: boolean; loading: boolean } {
  const { activeMarinaId } = useAuth();
  const { tick } = useMarinaModulesRefresh();
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .getModules()
      .then((d) => {
        const rows = (d.modules ?? []) as { module: string; is_enabled: boolean }[];
        const on = rows.some(
          (r) => (r.module === 'parking' || r.module === 'caravan') && r.is_enabled,
        );
        if (!cancelled) setEnabled(on);
      })
      .catch((err) => {
        if (!cancelled && err instanceof ApiError) setEnabled(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [activeMarinaId, tick]);

  return { parkingEnabled: enabled, loading };
}
